import { startWith, map, flatMap } from 'rxjs/operators';
import { FatTopBarSetup } from '../../../layout/fat-top-bar-layout/fat-top-bar-layout.component';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CompanysitesService } from '../company-sites.service';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-detail-site-layout',
  templateUrl: './detail-site-layout.component.html',
  styleUrls: ['./detail-site-layout.component.css']
})
export class DetailSiteLayoutComponent implements OnInit, OnDestroy {
  layoutSetup: Observable<FatTopBarSetup>;
  userHaveAccess: Object
  userHavePermissionForCategory: boolean = false;
  userSub : Subscription
  constructor(private auth: AuthService, private route: ActivatedRoute, private siteService: CompanysitesService) {
   this.userSub =  this.auth.user$.subscribe(user => {
      this.userHaveAccess = user['haveAccess']
      this.userHavePermissionForCategory = user['category']
    })
  }
  ngOnDestroy(): void {
    if(this.userSub)
    this.userSub.unsubscribe()
  }

  ngOnInit() {

    let siteId$ = this.route.params.pipe(map(params => {
      return params['siteId'];
    }));


    let siteData$ = siteId$.pipe(flatMap(siteId => this.siteService.getSiteById(siteId).pipe(map(value => {
      return {
        name: value?.data()['name'],
        siteId,
        isDepartmentActive: value?.data()['isDepartmentActive'],
        isProjectActive: value?.data()['isProjectActive'],
        strictGroup: value?.data()['strictGroup'],
      };
    }))))

    let sites$ = this.siteService.getSites$();

    this.layoutSetup = combineLatest(siteData$, sites$, siteId$).pipe(map(values => {

      const siteData = values[0];
      const sites = values[1];
      const siteId = values[2];


      let links = [{ name: "Systems", path: "/dashboard/sites/" + siteId + "/" }];

      if (this.userHaveAccess) {
        if (this.userHaveAccess['reports'] != false)
          links.push({ name: "Reports", path: "/dashboard/sites/" + siteId + "/report" })

        // if (this.userHaveAccess['employees'] != false)
        //   links.push({ name: "Users", path: "/dashboard/sites/" + siteId + "/users" })

        // Add Special Prices tab for users with access
        links.push({ name: "Special Prices", path: "/dashboard/sites/" + siteId + "/special-prices" })

      } else {
        links.push({ name: "Reports", path: "/dashboard/sites/" + siteId + "/report" })
        // links.push({ name: "Users", path: "/dashboard/sites/" + siteId + "/users" })
        // links.push({ name: "Category", path: "/dashboard/sites/" + siteId + "/categories" })
        if (this.userHavePermissionForCategory != false)
          links.push({ name: "Category", path: "/dashboard/sites/" + siteId + "/categories" })
        
        // Add Special Prices tab
        links.push({ name: "Special Prices", path: "/dashboard/sites/" + siteId + "/special-prices" })

      }


      const layoutObject = {
        title: "Site: " + siteData.name,
        links
        , sites
      };

      // v2 (root-collection) membership model.

        layoutObject.links.push({ name: "User & Group Management", path: "/dashboard/sites/" + siteId + "/membership-test" });
      // if (siteData.isProjectActive) layoutObject.links.push({ name: "Projects", path: "/dashboard/sites/" + siteId + "/project" });
      // if (siteData.isDepartmentActive) layoutObject.links.push({ name: "Departments", path: "/dashboard/sites/" + siteId + "/department" });



      return layoutObject;
    }));
    // this.layoutSetup.subscribe(data => console.log("siteSetupData:", data))
  }

}
